/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormDocument } from './FormDocument';
import {
    FormDocumentFromJSON,
    FormDocumentFromJSONTyped,
    FormDocumentToJSON,
    FormDocumentToJSONTyped,
} from './FormDocument';
import type { GetFormByTokenResponseTemplate } from './GetFormByTokenResponseTemplate';
import {
    GetFormByTokenResponseTemplateFromJSON,
    GetFormByTokenResponseTemplateFromJSONTyped,
    GetFormByTokenResponseTemplateToJSON,
    GetFormByTokenResponseTemplateToJSONTyped,
} from './GetFormByTokenResponseTemplate';

/**
 * 
 * @export
 * @interface GetFormByTokenResponse
 */
export interface GetFormByTokenResponse {
    /**
     * 
     * @type {FormDocument}
     * @memberof GetFormByTokenResponse
     */
    document: FormDocument;
    /**
     * 
     * @type {GetFormByTokenResponseTemplate}
     * @memberof GetFormByTokenResponse
     */
    template?: GetFormByTokenResponseTemplate | null;
    /**
     * Pre-filled claim data from AI metadata extraction or claim table
     * @type {{ [key: string]: any; }}
     * @memberof GetFormByTokenResponse
     */
    claimData?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the GetFormByTokenResponse interface.
 */
export function instanceOfGetFormByTokenResponse(value: object): value is GetFormByTokenResponse {
    if (!('document' in value) || value['document'] === undefined) return false;
    return true;
}

export function GetFormByTokenResponseFromJSON(json: any): GetFormByTokenResponse {
    return GetFormByTokenResponseFromJSONTyped(json, false);
}

export function GetFormByTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFormByTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'document': FormDocumentFromJSON(json['document']),
        'template': json['template'] == null ? undefined : GetFormByTokenResponseTemplateFromJSON(json['template']),
        'claimData': json['claimData'] == null ? undefined : json['claimData'],
    };
}

export function GetFormByTokenResponseToJSON(json: any): GetFormByTokenResponse {
    return GetFormByTokenResponseToJSONTyped(json, false);
}

export function GetFormByTokenResponseToJSONTyped(value?: GetFormByTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document': FormDocumentToJSON(value['document']),
        'template': GetFormByTokenResponseTemplateToJSON(value['template']),
        'claimData': value['claimData'],
    };
}

